import React from 'react';

import { groupItemsBy } from '../services/utils';

const CONTRACT_TYPES = ['OTC', 'CME', 'Physical'];

class ProductSelector extends React.Component {

    renderSuperList() {
        let markets = this.props.currentUser.markets;

        return markets.map((market, i) => {
            const marketProducts = products.filter(p => p.market_id == market.id);
            const groups = groupItemsBy(marketProducts, 'contract_type');              
            const contracts = CONTRACT_TYPES.filter(contract_type => !!groups[contract_type]);
            
            return contracts.map(contract_type =>
                <optgroup label={`${market.name} - ${contract_type}`} key={'markgr'+i+contract_type}>
                    {groups[contract_type].map((product, j) =>  
                        <option value={product.id} key={'prod'+j}>
                            {product.short_name} ({product.unit_name}, {product.contract_type})
                        </option>
                    )}
                </optgroup>
            );                
        });
    }

    renderRegularList() {
        let cmeCleared = this.props.currentUser.cme_cleared;
       

        const groups = groupItemsBy(this.props.products, 'contract_type');
        const contracts = CONTRACT_TYPES.filter(contract_type => !!groups[contract_type]);

        return contracts.map(contract_type =>
            <optgroup label={contract_type} key={'ctrgr'+contract_type}>
                {groups[contract_type].map((item, i) =>  
                    <option value={item.id} key={'prod'+i} disabled={!cmeCleared && item.contract_type == 'CME'}>
                        {item.short_name} ({item.contract_type})
                    </option>
                )}
            </optgroup>
        );
    }

	render() {
        if (!this.props.products || !this.props.products.length) return [];

        return (
            <select name={this.props.name} onChange={this.props.handleChange.bind(this)} value={this.props.product_id} disabled={this.props.mode == 'view' ? 'disabled' : ''}>
              <option value=''> -- choose product -- </option>
              { this.props.isSuperUser ? this.renderSuperList() : this.renderRegularList() }
            </select>
        )
    }
}

export default ProductSelector;



// WEBPACK FOOTER //
// ./source/components/productSelector.js